import { STALE_TIME } from "#app/http/ReactQueryProvider";
import { fetchProducts } from "#modules/products/infra/fetchProducts.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";

export const productsQuery = () => ({
  queryKey: queryKeys.products.all,
  queryFn: () => fetchProducts(),
  staleTime: STALE_TIME,
});
